export default __webpack_public_path__ + "locales/nl/InviteDialog.json?hash=beb4d692628c3b7a39ffcea359ba1fda";